import { ContactsLayout } from "@features/layout";

export const ContactsPage = () => {
  return <ContactsLayout />;
};
